import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { useState } from 'react'
import MedicalEquipment from './MedicalEquipment'
import ItEquipment from './itEquipment'
import { useIntl } from 'react-intl'
import { TabsConfig, useTabs } from '@hooks/useTabs'
import { BiotechOutlined, Storage } from '@mui/icons-material'

const EquipmentConfig = (intl: ReturnType<typeof useIntl>): TabsConfig => ({
  medicalEquipment: {
    id: 'medicalEquipment',
    label: intl.formatMessage({ id: 'medicalEquipments' }),
    component: MedicalEquipment,
    icon: <BiotechOutlined />,
  },
  ItEquipment: {
    id: 'ItEquipment',
    label: intl.formatMessage({ id: 'itEquipments' }),
    component: ItEquipment,
    icon: <Storage />,
  },
})

export default function Equipments() {
  const intl = useIntl()

  const TabsConfig = EquipmentConfig(intl)

  const { keys, index, onChange, Component } = useTabs(TabsConfig)

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          backgroundColor: '#fff',
          borderBottom: '1px solid',
          borderColor: 'grey.200',
          px: 4,
        }}
      >
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={index[0]}
          onChange={onChange[0]}
          aria-label="equipment-tabs"
          sx={{
            '& .MuiTabs-indicator': {
              height: 2,
              backgroundColor: 'primary.main',
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.875rem',
              minHeight: 48,
              mr: 4,
              px: 0,
              color: 'text.secondary',
              '&.Mui-selected': {
                color: 'primary.main',
              },
            },
          }}
        >
          {keys.map((key) => {
            return (
              <Tab
                key={key}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {TabsConfig[key].icon}
                    {TabsConfig[key].label}
                  </Box>
                }
                id={`tab-${key}`}
                aria-controls={`tabpanel-${key}`}
              />
            )
          })}
        </Tabs>
      </Box>
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          backgroundColor: '#f9fafb',
          
          p: 2,
        }}
      >
        {Component && <Component />}
      </Box>
    </Box>
  )
}
